import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/app/node_modules/@vercel/analytics/dist/react/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/src/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/app/src/styles/critical.css");
